import styles from "../assets/css/EditQuestion.module.css";
import { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../constants/constants";

const EditQuestion = ({ questionId, onClose }) => {
  const [answer, setAnswer] = useState("");
  const [question, setQuestion] = useState("");
  const [type, setType] = useState("1");
  const token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const getQuestionById = () => {
    axios
      .get(`${BASE_URL}/v0/faq/${questionId}`, { headers })
      .then((response) => {
        const result = response.data.result;
        if (result) {
          setQuestion(result.question);
          setAnswer(result.answer);
          setType(result.type?.toString() || "1"); 
        }
      })
      .catch((error) => {
        console.error("Ошибка при получении данных вопроса:", error);
      });
  };

  useEffect(() => {
    if (questionId) {
      getQuestionById();
    }
  }, [questionId]);

  const handleUpdateQuestion = (e) => {
    e.preventDefault();
    const body = {
      question,
      answer,
      type: parseInt(type, 10),
    };

    axios
      .patch(`${BASE_URL}/v0/faq/${questionId}`, body, { headers })
      .then((response) => {
        console.log("Вопрос обновлен:", response.data);
        onClose();
      })
      .catch((error) => {
        console.error("Ошибка при обновлении вопроса:", error);
      });
  };

  return (
    <div className={styles.modal}>
      <form onSubmit={handleUpdateQuestion} className={styles.container}>
        <div className={styles.box}>
          <div className={styles.text}>Редактировать</div>
          <img
            onClick={onClose}
            className={styles.closeicon}
            src="/images/close.svg"
            alt="close icon"
          />
        </div>
        <input
          className={styles.input}
          placeholder="Редактировать вопрос"
          type="text"
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          maxLength="150"
        />
        <input
          className={styles.input}
          placeholder="Редактировать ответ"
          type="text"
          value={answer}
          onChange={(e) => setAnswer(e.target.value)}
          maxLength="150"
        />
        <div className={styles.selectWrapper}>
          <label className={styles.selectLabel} htmlFor="type-select">
            Выберите тип:
            <select
              className={styles.select}
              id="type-select"
              value={type}
              onChange={(e) => setType(e.target.value)}
            >
              <option value="1">FAQ для пользователей</option>
              <option value="2">FAQ для водителей</option>
            </select>
          </label>
        </div>
        <div className={styles.box1}>
          <button type="submit" className={styles.savebtn}>
            Сохранить
          </button>
          <button onClick={onClose} className={styles.cancelbtn}>
            Отмена
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditQuestion;
